// Project thumbnails historically hold live-site URLs (rendered in an iframe).
// Newer entries can point at static screenshots instead; detect those so the
// UI can render a plain <img> (faster, and immune to X-Frame-Options blocks).
export const isImageUrl = (url) =>
  typeof url === "string" &&
  (/\.(png|jpe?g|gif|webp|avif|svg)(\?.*)?$/i.test(url) ||
    url.startsWith("/img/"));
